import React, { useState } from 'react'
import Tools from '../../../Misc/Tools';
import { UIProperties } from '../UIProperties';
import CoreGeneralButton from './core-general-button';
import { GeneralQuestionUIConfigOption } from './core-general-question-ui';

import "./core-general-feedback-ui.css"
import { UIBaseImplementation } from '../../../UI/UIBaseImplementation';
import { parseDynamicHtml, TextHtmlTagType } from '../../../../misc/tools';

export interface GeneralFeedbackUIBaseImplementation {
}

class CoreGeneralFeedbackUIBaseImplementation extends UIBaseImplementation {
	public getImplementation(config: CoreGeneralFeedbackUIConfig): GeneralFeedbackUIBaseImplementation {
		return {
		}
	}
}

export const coreGeneralFeedbackUIBaseImplementation = new CoreGeneralFeedbackUIBaseImplementation();

const CoreGeneralFeedbackUI = (props: UIProperties<CoreGeneralFeedbackUIConfig>) => {
	const baseImplementation = coreGeneralFeedbackUIBaseImplementation.getImplementation(props.parameters);
	return (
		<div className="modal-disable-select center-element core-general-feedback-ui-container" style={{
		}}>
			<div className="modal-disable-select center-element core-general-feedback-inner-cont-container" style={{
			}}>
				<div className='core-general-feedback-inner-cont-row-right'>
					<p tabIndex={0} className=' core-general-feedback-inner-cont-title'>{props.parameters.title}</p>
				</div>

				<div className='core-general-feedback-inner-cont-description core-general-feedback-inner-cont-row' style={{marginBottom: '10px'}}>
				<div className='core-general-feedback-ui-sub-container center-element-horizontal'>
					<div className='center-element-horizontal core-general-feedback-ui-sub-container-question-title'>
						<p className='center-element '>You Selected</p>
					</div>

					{props.parameters.selectedOptions ? (<div className='core-general-feedback-ui-sub-container-question-single-option' key={Tools.generateGuid()}>
						<CoreGeneralButton width= '100%'
							height= '100%'
							onClick= {() => {}}
							onRenderContent= {() => {
								return (
									<p className='center-element'>{props.parameters.selectedOptions.map((option: GeneralQuestionUIConfigOption, indx: number) => {
										return option.title;
									}).join(', ')}</p>
								)
							}}
							isSelected= {false}
							isDisabled={true}
							ariaLabel= {''}></CoreGeneralButton>
					</div>) : (null)}

					<div className='core-general-feedback-ui-sub-container-desc-container'>
						<div className='center-element-horizontal core-general-feedback-ui-sub-container-desc-container-inner' dangerouslySetInnerHTML={{ __html: parseDynamicHtml(props.parameters.selectedOptions ? props.parameters.selectedOptions.map((option: GeneralQuestionUIConfigOption, indx: number) => {
							return option.feedbackHtml;
						}).join('<br /> <br />') : props.parameters.feedbackHtml) }}>
						</div>
					</div>

					<div className='center-element-horizontal core-general-feedback-ui-sub-container-question-submit'>
						<CoreGeneralButton width= '100%'
							height= '100%'
							onClick= {props.parameters.onButtonClicked}
							onRenderContent= {() => {
								return (
									<p className='center-element'>{'Continue'}</p>
								)
							}}
							isSelected= {false}
							isDisabled={false}
							ariaLabel= {'Continue'}></CoreGeneralButton>
					</div>
				</div>
				</div>
			</div>
		</div>
	);

};

export interface CoreGeneralFeedbackUIConfig {
	title: string;
	selectedOptions?: GeneralQuestionUIConfigOption[];
	feedbackHtml?: string;
	onButtonClicked: () => void;
}

export default CoreGeneralFeedbackUI;